import { QueryClient } from "react-query";

export const DEFAULT_STALE_TIME = (3 * 60000);

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            //refetchOnWindowFocus: false,
            staleTime: DEFAULT_STALE_TIME,
            refetchOnWindowFocus: false, // Disables focus refetch globally
        }
    }
});



